import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class BackOfficeExpropriationTrasformer  {
    _originalTypeClassName = "zERP.BO.BackOfficeExpropriationTrasformer";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
BackOfficeExpropriationTrasformer.translate = translateService;
}
this.BackOfficeExpropriationTrasformerKey = null;
this._key = this.BackOfficeExpropriationTrasformerKey = 0; 
}

static translate: TranslateService;
_key: any;
private _BackOfficeExpropriationTrasformerKey:any;
get BackOfficeExpropriationTrasformerKey(): any {
    return this._BackOfficeExpropriationTrasformerKey;
  }
set BackOfficeExpropriationTrasformerKey(value: any) {
    this._BackOfficeExpropriationTrasformerKey = value;
    this._key = value;
  }

static GetExpenseGroupKey(document: any,config: any,execution: any): any{return Joove.Common.safeNumber(document.protocolYear) + "_" + document.protocolNo + "_" + Joove.Common.safeNumber(document.decisionAA);
}
static GetIncomeGroupKey(document: any,config: any,execution: any): any{return Joove.Common.safeNumber(document.decisionAa) + "";
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.BackOfficeExpropriationTrasformerKey == null || $this.BackOfficeExpropriationTrasformerKey == 0;
            }


}